import { typesetKatex } from '@utils/common';
import { useIsomorphicLayoutEffect } from '@utils/react';

/**
 * load and initially typeset MathJax when the application has been hydrated
 * and bootstraping in general is already in progress.
 */
function useKatex(node, extraDeps = []) {
  useIsomorphicLayoutEffect(() => {
    typesetKatex(node);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [node, ...extraDeps]);
}

export { useKatex };
//# sourceMappingURL=katex.js.map
